module.exports = __webpack_public_path__ + "static/media/19-iveco.fabe2a12.jpg";